import { CAMERA_MODE_INSPECT } from "./camera-system.js";
import { setMatrixWorld } from "../utils/three-utils";
import configManager from "../singleton/ConfigManager.js";

let viewingCamera;
let uiRoot;
export class ScenePreviewCameraSystem {
  constructor() {
    this.entities = [];
  }

  register(el) {
    this.entities.push(el);
  }

  unregister(el) {
    this.entities.splice(this.entities.indexOf(el), 1);
  }

  tick() {
    viewingCamera = viewingCamera || document.getElementById("viewing-camera");
    uiRoot = uiRoot || document.querySelector(".ui-root");
    const entered = viewingCamera && viewingCamera.sceneEl.is("entered");
    const isGhost = !entered && uiRoot && uiRoot.classList.contains("isGhost");
    for (let i = 0; i < this.entities.length; i++) {
      const el = this.entities[i];
      const hubsSystems = AFRAME.scenes[0].systems["hubs-systems"];
      if (el && (!hubsSystems || (hubsSystems.cameraSystem.mode !== CAMERA_MODE_INSPECT && !isGhost && !entered))) {
        if (configManager.config.previewRotation.enabled) {
          el.components["scene-preview-camera"].tick2();
        }

        if (hubsSystems && viewingCamera) {
          el.object3D.updateMatrices();
          setMatrixWorld(viewingCamera.object3DMap.camera, el.object3D.matrixWorld);
        }
      }
    }
  }
}
